import React, { useContext } from 'react'
import { CalendarContext } from '../../context/CalendarContext';
import '../../styles/errorModal.scss'

const ErrorModal = ({ errorMsg, errorTitleMessage }) => {
  const { setIsModalOpen } = useContext(CalendarContext);
  return (
    <div className="error-modal-content">
      <div className='result-icon'>
        <i className="fas fa-times-circle"></i>
      </div>
      <h2>Agenda Fallida!</h2>
      <p>{errorTitleMessage}</p>
      <div className="error-details">
        <span>
          {errorMsg}
        </span>
      </div>
      <button onClick={() => setIsModalOpen(false)}>Cerrar</button>
    </div>
  )
}

export default ErrorModal